import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ENSGridResizeType, INSGridConfig } from '@norfolk-southern/accessns-components';
import { ColDef, GridOptions } from 'ag-grid-community';

import { NSAccessorialInventoryConstants } from '@ruby/configs/accessorial-inventory.constants';
import { IAccessorialInventory } from '@ruby/modules/accessorial-inventory/models/accessorial-inventory.interface';
import { EGridType } from '@ruby/shared/enums/grid.enums';
import { EInventoryRoute } from '@ruby/shared/enums/inventory-management.enums';
import { IGridPrintTitle } from '@ruby/shared/models/commons/grid.interface';

@Component({
  selector: 'ng-accessorial-inventory',
  templateUrl: './accessorial-inventory.component.html',
  styleUrls: ['./accessorial-inventory.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccessorialInventoryComponent implements OnChanges {
  @Input() loading!: boolean;
  @Input() data!: Array<IAccessorialInventory>;
  @Input() name!: EGridType;
  @Input() printTitle!: IGridPrintTitle;
  @Input() type?: EInventoryRoute;
  resizeType = ENSGridResizeType.SIZECOLUMNSTOFIT;
  columns: Array<ColDef> = NSAccessorialInventoryConstants.accessorialColumnsDef;
  config: INSGridConfig = NSAccessorialInventoryConstants.config;
  options: GridOptions = NSAccessorialInventoryConstants.options;

  constructor() { }

  get title(): string {
    return this.name.replace(/_/g, ' ');
  }

  get gridName(): string {
    return `${ this.type === EInventoryRoute.HISTORY ? 'HISTORY_' : '' }${ this.name }`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.printTitle && changes.printTitle.currentValue) {
      this.config = { ...this.config, headerDetails: changes.printTitle.currentValue };
    }
    if (changes.type && changes.type.currentValue) {
      this.config = {
        ...this.config,
        groups: (changes.type.currentValue === EInventoryRoute.HISTORY)
          ? NSAccessorialInventoryConstants.accessorialHistoryGroups
          : NSAccessorialInventoryConstants.accessorialGroups
      };
    }
  }
}
